import { render, staticRenderFns } from "./ProjectsView.vue?vue&type=template&id=1dcb0760&scoped=true&"
import script from "./ProjectsView.vue?vue&type=script&lang=js&"
export * from "./ProjectsView.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsView.vue?vue&type=style&index=0&id=1dcb0760&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcb0760",
  null
  
)

export default component.exports